var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcWalletBitget = function SvgIcWalletBitget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_wallet_bitget_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic_wallet_bitget_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0v20h20V0Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ic_wallet_bitget_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H0v20h20V0Z",
    fill: "#54FFF5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ic_wallet_bitget_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.053 15.516c-3.344 9.41 14.546 6.752 23.909 4.247 9.582-3.18 2.959-17.198-3.914-17.509-6.873-.31.852 6.482-4.986 8.422-5.838 1.94-10.828-6.921-15.009 4.84Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ic_wallet_bitget_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.68-3.58C4.927-8.373-1.321-1.875-4.225 1.974-6.997 6.16.235 9.778 3.072 7.815 5.909 5.853.607 5.472 2.295 2.92 3.982.37 8.874 2.412 6.68-3.58Z",
    fill: "#00FFF0",
    fillOpacity: 0.67
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ic_wallet_bitget_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.537 17.611c-2.392-8.051-12.7-3.811-17.554-.684-4.67 3.701 6.418 14.35 11.023 13.806 4.605-.545-3.694-5.18-.85-7.438 2.843-2.258 10.373 4.38 7.381-5.684Z",
    fill: "#9D81FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ic_wallet_bitget_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.04-8.387C16.88-14.534 9.49-9.45 6.44-6.14 3.77-2.394 17.52 4.471 21.338 3.295c3.816-1.177-5.204-3.611-3.58-5.896C19.38-4.885 28.493-.704 22.04-8.387Z",
    fill: "#4D94FF"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.705 11.637h2.867L7.311 8.355l3.303-3.282.9-.875H8.538l-3.79 3.81a.49.49 0 0 0 .002.693l2.955 2.936Zm1.723-3.274h-.022.022Zm0 0 3.261 3.282-3.303 3.282-.9.875h2.976l3.79-3.81a.49.49 0 0 0-.002-.693l-2.955-2.936H9.428Z",
    fill: "#000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ic_wallet_bitget_svg__c",
    x: -7.05,
    y: -5.448,
    width: 44.497,
    height: 35.268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.846,
    result: "effect1_foregroundBlur_42145_134766"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ic_wallet_bitget_svg__d",
    x: -12.54,
    y: -12.968,
    width: 27.468,
    height: 29.024,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.846,
    result: "effect1_foregroundBlur_42145_134766"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ic_wallet_bitget_svg__e",
    x: -18.834,
    y: 5.285,
    width: 34.754,
    height: 33.16,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.846,
    result: "effect1_foregroundBlur_42145_134766"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ic_wallet_bitget_svg__f",
    x: -1.593,
    y: -18.965,
    width: 33.609,
    height: 30.086,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.846,
    result: "effect1_foregroundBlur_42145_134766"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_wallet_bitget_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#fff"
  })))));
};
export default SvgIcWalletBitget;